import './app.less';

import config from '../config';
import banner from './banner';
import invite from './invite';
import mark from '../mark';
import dialog from './dialog'
import player from './video'
import utils from './utils'
import message from './message'

import '../user';

utils.wxShare()
invite.start();

player.init()

const ua = navigator.userAgent;
const isMobile = !!ua.match(/AppleWebKit.*Mobile.*/);

let is2 = 0
if (!isMobile) {
    banner.backAni();
    banner.mouseMove();
    is2 = 2
}

dialog.init(is2)

if (!($('.applyBtn button').hasClass('disable'))) {
    $('.applyBtn').click(function () {
        $('.applyBtn button').addClass('disable')
        dialog.show(is2)
    })
}

if (!($('.applyBtn-web').hasClass('disable'))) {
    $('.applyBtn-web').click(function () {
        $('.applyBtn-web').addClass('disable')
        dialog.show(is2)
    })
}


const accountUrl = config.accountUrl;
const apiUrl = config.apiUrl;
const caimiUrl = config.caimiUrl;
const facedetectUrl = config.facedetectUrl;
const httpProtocol = config.httpProtocol;
const loginDirect = config.loginDirect;
const registerDirect = config.registerDirect;
const webUrl = config.webUrl;
const staticUrl = config.staticUrl;
const spmMark = 'xhzy_mp_index';

// 设置跳转链接
const urlArr = [
    {
        name: 'BannerUrl',
        url: `${loginDirect}${encodeURIComponent(location.href)}`
    },
    // {
    //     name: 'LoginUrl',
    //     url: `${loginDirect}${encodeURIComponent(location.href)}&type=1`
    // },
    {
        name: 'RegisterUrl',
        url: `${registerDirect}${encodeURIComponent(location.href)}&type=1`
    }, {
        name: 'CopyrightLogin',
        url: `${httpProtocol}${webUrl}/banquan/all`
    }, {
        name: 'TTSLoginUrl',
        url: `${httpProtocol}${webUrl}/tts`
    }, {
        name: 'FenfaLoginUrl',
        url: `${httpProtocol}${webUrl}/fenfa`
    }, {
        name: 'CaimiUrl',
        url: `${caimiUrl}?from=${spmMark}`
    }, {
        name: 'FaceDetectUrl',
        url: `${httpProtocol}${webUrl}/face`
    }, {
        name: 'PersonaUrl',
        url: `${httpProtocol}${webUrl}/persona`
    }, {
        name: 'TianchengUrl',
        url: `${httpProtocol}${webUrl}/2410`
    }, {
        name: 'ChatbotUrl',
        url: `${httpProtocol}${webUrl}/chatbot`
    }
];

urlArr.map((item) => {
    // if (isMobile) return;
    $('.' + item.name).attr('href', item.url);
});

// 检查是否已登录
// $.ajax({
//   url: httpProtocol + accountUrl + '/api/uic/get/user.json',
//   jsonp: 'callback',
//   dataType: 'jsonp',
//   success: (data) => {
//     var ua = navigator.userAgent;
//     var isMobile = !!ua.match(/AppleWebKit.*Mobile.*/);
//     if (data && data.code === 'SW-010000' && window.swToken && !isMobile && !location.pathname.split('/index.html/confirm/')[1]) {
//       // 登录成功
//       location.href = `${httpProtocol}${webUrl}/banquan/all?from=${spmMark}`;
//     } else {
//       // 没有检测到是否登录
//     }
//   },
//   error: (err) => {
//     // 请求失败
//     console.log('error', err);
//   }
// });

// $('.product-item').click((e) => {
//   const hasMobile = $(e.currentTarget).hasClass('mobile');
//   $('.product-item').removeClass('mobile');
//   if (hasMobile && location.pathname.split('/index.html/confirm/')[1]) return;
//   $(e.currentTarget).addClass('mobile');
// });

if (isMobile) {
    $('.product-item').addClass('mobile');
}

$('.product-item').hover(() => {
    $('.product-item').removeClass('active');
});

if (!isMobile) {
    $('.product-item.firstItem').addClass('active');
}

$(window).resize((e) => {
    if (e.target && e.target.innerWidth < 768) {
        $('.product-item.firstItem').removeClass('active');
    }
});

// 弹窗登录
$(document).on('click', '.LoginModalUrl', function () {
  mark.markPoint('home_login');
})

// mark start
$('.LoginUrl').click(() => {
    mark.markPoint('home_login');
});
$('.RegisterUrl').click(() => {
    mark.markPoint('home_register');
});
$('.CopyrightLogin').click(() => {
    mark.markPoint('home_copyright');
});
$('.TTSLoginUrl').click(() => {
    mark.markPoint('home_tts');
});
$('.FenfaLoginUrl').click(() => {
    mark.markPoint('home_fenfa');
});
$('.CaimiUrl').click(() => {
    mark.markPoint('home_caimi');
});
$('.FaceDetectUrl').click(() => {
    mark.markPoint('home_face');
});
$('.TianchengUrl').click(() => {
    mark.markPoint('home_tiancheng');
});
$('.PersonaUrl').click(() => {
    mark.markPoint('home_persona');
});
$('.ChatbotUrl').click(() => {
    mark.markPoint('home_chatbot');
});
$('.BannerUrl').click(() => {
    mark.markPoint('home_banner');
});
// mark end
//

// 登陆
let login = new iframeLogin({
    themeColor: "#4285f4",
    hideResetPassword: false,
    callback: function (e) {
        console.log(e);
        if(e && e.code === 'SW-010000'){
            login.hide();
            location.reload();
        }else{
            message.showErrorBox(e && e.msg ? e.msg : '登陆失败', 2000)
        }
    },
    validateCallback: e => {}
});
login.init();

$(document).on("click", '.LoginUrl', function (e) {
    login.show();
});




// WEBPACK FOOTER //
// ./src/pages/vlog/app.js